module.exports = __webpack_public_path__ + "img/marker default.846e7a6a.png";